import {
  Select as ChakraSelect,
  FormControl,
  FormErrorMessage,
  FormLabel,
 } from '@chakra-ui/react';
 import { forwardRef } from 'react';
 import { IoMdArrowDropdown } from 'react-icons/io';
 
 const InputBase = (
  { name, label, error = null, options, value, labelFontSize = 'xs', children, ...rest },
  ref
 ) => {
  return (
   <FormControl isInvalid={!!error}>
    {!!label && (
     <FormLabel
      htmlFor={name}
      fontSize={labelFontSize}
      color='#818A8F'
      lineHeight='14.88px'
      whiteSpace='nowrap'
     >
      {label}
     </FormLabel>
    )}
 
    <ChakraSelect
     name={name}
     id={name}
     height='48px'
     fontSize='sm'
     bg='white'
     color='black.100'
     borderRadius='8px'
     cursor='pointer'
     border='1px solid #B8CAE8'
     fontWeight={600}
     value={value}
     _disabled={{
      bg: '#CCCFD1',
      color: '#515D63',
      borderColor: '#CCCFD1',
      cursor: 'default',
      _hover: {
       border: 'unset',
       borderColor: 'transparent',
       outline: '0px',
      },
     }}
     icon={<IoMdArrowDropdown color='#292B30' opacity={0.5} fontSize='36px' />}
     ref={ref}
     {...rest}
    >
     {/* Aceita as duas formas: <option> passado como filho e a prop `options`.
         Sem renderizar `children` o select saía vazio para quem usa a 1ª. */}
     {children}
     {options?.map((option, index) => (
      <option value={option?.value} key={index}>
       {option?.label}
      </option>
     ))}
    </ChakraSelect>
 
    {!!error && <FormErrorMessage fontSize='13px'>{error.message}</FormErrorMessage>}
   </FormControl>
  );
 };
 
 export const Select = forwardRef(InputBase);
 